import React from "react";
import styled from "styled-components";

const StyledMUITextFieldDatePicker = styled.div`
  input {
    border-radius: 8px !important;
    height: 50px;
    min-width: 150px;
    padding: 12px 16px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: none;
    color: var(--colorTextPrimary);
    font-family: var(--primaryTextFont);
    font-size: 14px;
    background-color: white;
    box-shadow: inset 0 0 0 1px var(--colorBorder);
  }

  input:hover {
    box-shadow: inset 0 0 0 2px var(--colorBorder);
  }

  input:focus {
    box-shadow: inset 0 0 0 2px var(--primaryColor);
  }

  input[data-invalid="true"] {
    box-shadow: inset 0 0 0 2px var(--colorErrorDark);
  }

  input[data-invalid="true"]:focus {
    box-shadow: inset 0 0 0 2px var(--colorErrorDark);
  }
`;

const HelperText = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 14px;
  font-family: var(--primaryTextFont);
  line-height: 1.43;
  color: var(--colorErrorDark);
`;

export const DatePicker = ({
  id,
  name = "",
  value,
  min,
  max,
  ariaLabel,
  placeholder,
  disabled = false,
  required = false,
  ariaRequired,
  error = false,
  helperText = "",
  onChange = () => {},
  onFocus = () => {},
}) => {
  const resolvedAriaRequired =
    ariaRequired === undefined ? (required ? true : undefined) : ariaRequired;
  const helperId =
    helperText && id ? `${String(id)}-datepicker-helper` : undefined;

  return (
    <StyledMUITextFieldDatePicker className="mui-datepicker">
      <input
        type="date"
        className="input-calendar-field"
        id={id}
        name={name}
        value={value}
        placeholder={placeholder}
        data-invalid={error ? "true" : "false"}
        {...(ariaLabel ? { "aria-label": ariaLabel } : {})}
        {...(helperId ? { "aria-describedby": helperId } : {})}
        {...(resolvedAriaRequired === true ? { "aria-required": "true" } : {})}
        {...(resolvedAriaRequired === false ? { "aria-required": "false" } : {})}
        {...(error ? { "aria-invalid": "true" } : {})}
        {...(required ? { required: true } : {})}
        {...(disabled ? { disabled: true } : {})}
        {...(min && { min })}
        {...(max && { max })}
        onChange={onChange}
        onFocus={onFocus}
      />
      {helperText && helperId ? (
        <HelperText id={helperId} role="status" aria-live="polite">
          {helperText}
        </HelperText>
      ) : null}
    </StyledMUITextFieldDatePicker>
  );
};
